import React from 'react';
import { CRAFT_ELEMENTS } from '../config/craftElements';

export interface Props {
  children?: any;
}

const MultiReactElementAppender = ({ children }: Props): React.ReactElement => {
  return <>{children}</>;
};

export const MultiReactElementAppenderProps = {};

export default MultiReactElementAppender;

MultiReactElementAppender.craft = {
  name: CRAFT_ELEMENTS.MULTI_REACT_ELEMENT_APPENDER,
  props: MultiReactElementAppenderProps,
};
